import {LectioJSUtils} from "./../LectioJSUtils";
import { CKEditorLectio, EditorConfig } from "./Types";

export namespace LCDocumentEditorUtils {
	// I partial postbacks, skal vi lige have destoryed de gamle CKEditorer, så der bliver pænt ryddet op.
	function UpdatePanel_PageLoading_CleanUpEditors(sender: any, args: any) {
		const arr = args.get_panelsUpdating();
		const arr2 = args.get_panelsDeleting();
		for (const divid of arr.concat(arr2)) {
			const olddiv = $("#" + divid);

			for (const i in CKEDITOR.instances) {
				const editor = CKEDITOR.instances[i]!;
				const dmelem = $("#" + i);
				if (dmelem.parents("#" + divid).length) {
					editor.destroy();
					//alert('CleanUp ' + i);
				}
			}
		}
	}

	export function UpdateAllCKEditors() {
		for (const ed of LCDocumentEditorUtils.GetAllEditorInstances()) {
			ed.updateElement();
		}
	}

	export function GetAllEditorInstances(): readonly CKEDITOR.editor[] {
		const arr: CKEDITOR.editor[] = [];
		for (const id in CKEDITOR.instances) {
			const ed = CKEDITOR.instances[id];
			if (!ed)
				throw new Error('ed');
			arr.push(ed);
		}
		return arr;
	}

	export function GetResourceUrl(serializedId: string, filename: string) {
		return LectioJSUtils.GetBaseSchoolURL() + '/lc/ext/' + serializedId + (filename ? '/' + encodeURIComponent(filename) : '');
	}

	export function TryGetResourceFilename(url: string) {
		const reLectioPrefix = new RegExp('^/lectio/\\d+');
		let urlCleaned = url;
		if (url.match(reLectioPrefix))
			urlCleaned = url.replace(reLectioPrefix, '');

		// "/lc/ext/DT123123123/min.docx"
		const reResource1 = new RegExp('/lc/[a-zA-Z]\\w*/[^/]+/([^/?]+)');
		const match1 = urlCleaned.match(reResource1);
		if (match1)
			return decodeURIComponent(match1[1]);

		// "/lc/12572560289/res/12572560291/circle_darkg.docx"
		const reResource2 = new RegExp('/lc/[^/]+/res/[^/]+/([^/?]+)');
		const match2 = urlCleaned.match(reResource2);
		if (match2)
			return decodeURIComponent(match2[1]);

		return '';
	}

	export function GetToolbarObject(editor: CKEDITOR.editor): JQuery {
		const domid = '#cke_' + editor.name;
		const toolbar = $(domid + " .cke_top");
		return toolbar;
	}

	export function GetEditorConfig(editor: CKEditorLectio): EditorConfig {
		const cfg = editor.editorConfig;
		if (!cfg)
			throw new Error('Har ikke editor config.');
		return cfg;
	}

	export const buttonsToSuppress: {
		maximize?: CKEDITOR.dialog.definition.button;
		undo?: CKEDITOR.dialog.definition.button;
		redo?: CKEDITOR.dialog.definition.button;
		[command: string]: CKEDITOR.dialog.definition.button | undefined;
	} = {
		maximize: undefined,
		undo: undefined,
		redo: undefined
	};

	export let Year: number;
}
